import { render, staticRenderFns } from "./_menuicon.vue?vue&type=template&id=057f6bb1&"
import script from "./_menuicon.vue?vue&type=script&lang=js&"
export * from "./_menuicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports